"use client";

// مرز code-split سمت client: dynamic() فقط داخل کامپوننت client چانک جدا می‌سازد
// (از Server Component همه‌ی کد client صفحه‌ها در یک چانک مشترک می‌آمد).
import dynamic from "next/dynamic";

// بدون loading fallback: با آن، HTML اول فقط لودینگ بود و محتوای صفحه در یک div مخفی می‌ماند
// تا اسکریپت جابه‌جایش کند (با JS خاموش فقط لودینگ دیده می‌شد).
export default dynamic(() => import("./_component"));
